<div class="email-welcome">
    <div class="email-welcome__content" *ngIf="!loading && !error">
        <h1 class="email-welcome__title">Ласкаво просимо до спільноти FOF</h1>
        <p class="email-welcome__subtitle">
            Підписку успішно підтверджено.<br>
            Тепер ми можемо бути з тобою на зв'язку.
        </p>
        <a class="email-welcome__cta" [routerLink]="currentLang.defended ? '/' : '/' + currentLang.slug">До каталогу FOF</a>
    </div>

    <div class="email-welcome__content" *ngIf="loading">
        <p class="email-welcome__loading">Завантаження...</p>
    </div>

    <div class="email-welcome__content" *ngIf="!loading && error">
        <p class="email-welcome__error">Невалідне або застаріле посилання.</p>
    </div>
</div>
